export enum DocumentTypes {
  Image = 1,
  Video = 2,
  Document = 3,
  Link = 4,
}
